import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import {useGrid} from '../../../../hooks/useGrid';
import ReviewsWidgetItem from './components/ReviewsWidgetItem';

const ReviewsWidget = props => {
  const { id, user, history } = props;

  const grid = useGrid(
    ENDPOINT.COLLECTION.CANDIDATE_PROFILE_REVIEWS,
    null,
    false
  );

  useEffect(() => {
    grid.actions.fetch({ id });
  }, [id]);

  return Number(grid.data.rowsCount) > 0 ? (
    <div className="sidebar__widget">
      {grid.data.isFetching && <LoadMask relative />}
      <div className="sidebar__block">
        <h3 className="sidebar__title">Reviews</h3>
      </div>

      <div className="sidebar__block">
        <div className="sidebar__table">
          {grid.data.rows.map(record => (
            <ReviewsWidgetItem
              key={record.ReviewID}
              user={user}
              history={history}
              record={record}
            />
          ))}
        </div>
        {Number(grid.data.rowsCount) > Number(grid.data.perPage) && (
          <div className="sidebar__pagination">
            <PagePagination
              page={grid.data.page}
              perPage={grid.data.perPage}
              count={grid.data.rowsCount}
              pageRangeDisplayed={3}
              controlFunc={grid.actions.readPage}
              hideFirstLastPages={false}
              hideNavigation={true}
              minimalStyle={true}
              scrollToTop={false}
            />
          </div>
        )}
      </div>
    </div>
  ) : null;
};

ReviewsWidget.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default ReviewsWidget;
